import React from 'react';
import DateInput from '../../../../../components/DateInput';
import { fromDateTimeLocalValue, toDateTimeLocalValue } from '../../../../../utils/dateUtils';

interface DateTimeInputProps {
  id: string;
  value: string | null | undefined;
  /** Gets the UTC date once the field holds a whole one, or null when it's emptied */
  onChange: (value: string | null) => void;
  disabled?: boolean;
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({ id, value, onChange, disabled }) => (
  <DateInput
    id={id}
    type="datetime-local"
    value={toDateTimeLocalValue(value)}
    onChange={typed => onChange(fromDateTimeLocalValue(typed))}
    disabled={disabled}
  />
);

export default DateTimeInput;
